"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurerService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const insurer_address_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-address.entity");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const address_service_1 = require("../address/address.service");
const look_up_repository_1 = require("../look-up/look-up.repository");
const insurer_repository_1 = require("./insurer.repository");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const constants_2 = require("../../../../service-lib/src/lib/constants");
let InsurerService = class InsurerService {
    constructor(insurerRepository, addressService, lookUpRepository, dataSource, lookUpValidation, masterValidation) {
        this.insurerRepository = insurerRepository;
        this.addressService = addressService;
        this.lookUpRepository = lookUpRepository;
        this.dataSource = dataSource;
        this.lookUpValidation = lookUpValidation;
        this.masterValidation = masterValidation;
    }
    // Adds a new insurer with addreess using the repository.
    async addInsurer(createInsurerDto, userId) {
        const queryRunner = this.dataSource.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            // Check if the insurer already exists
            const existingInsurer = await this.insurerRepository.findInsurerByName(createInsurerDto.insurerName);
            if (existingInsurer && existingInsurer.length > 0) {
                throw new common_1.ConflictException(`An insurer with the name "${createInsurerDto.insurerName}" already exists.`);
            }
            await this.masterValidation.validateMasterIds(createInsurerDto, constants_1.MASTER_DATA);
            await this.lookUpValidation.validateDynamicLookupValues(createInsurerDto, constants_1.LOOK_UP_DATA);
            // Set default status and metadata
            const insurerStatus = await this.lookUpRepository.findByLookUpKey(constants_1.DEFAULT_INSURER_STATUS_ACTIVE_KEY);
            createInsurerDto.statusLid = insurerStatus[0].id;
            createInsurerDto.createdAt = new Date();
            createInsurerDto.updatedAt = new Date();
            createInsurerDto.createdBy = userId;
            createInsurerDto.updatedBy = userId;
            // Add insurer
            const insurer = await this.insurerRepository.addInsurer(queryRunner, createInsurerDto);
            // Save address details
            const addressMappings = [];
            if (createInsurerDto.address && createInsurerDto.address.length > 0) {
                for (const addressDto of createInsurerDto.address) {
                    const address = await this.addressService.addAddress(addressDto, userId);
                    const insurerAddress = new insurer_address_entity_1.InsurerAddress();
                    insurerAddress.insurerId = insurer.id;
                    if (!address || !address.id) {
                        throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.addressIdNotfound));
                    }
                    insurerAddress.addressId = address.id;
                    await this.insurerRepository.addInsurerAddress(queryRunner, insurerAddress);
                    addressMappings.push(address);
                }
            }
            // Commit the transaction
            await queryRunner.commitTransaction();
            const insurerDetails = await this.insurerRepository.fetchInsurerByIdWithDetails(insurer.id);
            if (!insurerDetails) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToAddInsurer));
            }
            // Return the detailed response
            // Prepare the response
            const response = {
                ...insurerDetails,
            };
            // Remove metadata fields from the response
            (0, response_utils_1.removeMetadataFields)(response);
            return response;
        }
        catch (error) {
            // Rollback the transaction in case of an error
            await queryRunner.rollbackTransaction();
            if (error instanceof common_1.HttpException) {
                throw error;
            }
            if (error instanceof common_1.ConflictException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToAddInsurer));
        }
        finally {
            await queryRunner.release();
        }
    }
    // Gets all insurers using the repository.
    async getAllInsurers(page, limit, sortBy, search, searchBy, userId) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search || "");
            const sortParams = (0, helper_utils_1.mapSortParams)(sortBy);
            if (sortParams) {
                const tpaSortOrderSearch = sortParams.find((item) => item.field ===
                    constants_2.sortRealtionsMapping.PARENT_INSURER_PHONE_NUMBER_SORT_KEY);
                if (tpaSortOrderSearch) {
                    tpaSortOrderSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_INSURER_PHONE_NUMBER_SORT;
                }
            }
            const { data, count } = await this.insurerRepository.fetchAllInsurersWithAddress(page, limit, searchParams, sortParams, searchBy, userId);
            const insurerStatus = await this.lookUpRepository.findByLookUpKey(constants_1.DEFAULT_INSURER_STATUS_ACTIVE_KEY);
            const totalActiveInsurers = await this.insurerRepository.getTotalActiveInsurers(insurerStatus[0].id);
            return {
                insurers: data,
                total: count,
                totalActiveInsurers: totalActiveInsurers,
                totalActivePolicies: 0,
            };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToFetchInsurers || error.message));
        }
    }
    // Gets a single insurer by ID using the repository.
    async getInsurerById(insurerId) {
        try {
            const insurer = await this.insurerRepository.fetchInsurerByIdWithDetails(insurerId);
            if (!insurer) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.insurerNotFound));
            }
            (0, response_utils_1.removeMetadataFields)(insurer);
            return insurer;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToFetchInsurer));
        }
    }
    // Modifies an insurer by ID using the repository.
    async modifyInsurer(insurerId, updateInsurerDto, userId) {
        const queryRunner = this.dataSource.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            const insurer = await this.insurerRepository.fetchInsurerById(insurerId);
            if (!insurer) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.insurerNotFound));
            }
            await this.lookUpValidation.validateDynamicLookupValues(updateInsurerDto, constants_1.LOOK_UP_DATA);
            // Filter out the `address` field before updating the insurer
            const { address, ...insurerDetails } = updateInsurerDto;
            insurerDetails.updatedBy = userId;
            insurerDetails.updatedAt = new Date();
            // Update the insurer details using a transaction
            const updatedInsurer = await this.insurerRepository.modifyInsurer(queryRunner, insurerId, insurerDetails);
            // Handle address updates
            const addressMappings = [];
            if (address) {
                // retrieves the existing address
                const existingAddressIds = await this.insurerRepository.getEntityTableMapIds(constants_2.INSURER_MAP_TABLE_DELETE_FIELDS.INSURER_ADDRESS, constants_2.INSURER_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, { insurerId: insurerId });
                if (address.length > 0) {
                    for (const addressDto of address) {
                        let updatedAddress;
                        if (addressDto.id) {
                            const index = existingAddressIds.indexOf(addressDto.id);
                            if (index !== -1) {
                                existingAddressIds.splice(index, 1);
                            }
                            updatedAddress = await this.addressService.updateAddressById(addressDto.id, addressDto, userId);
                        }
                        else {
                            updatedAddress = await this.addressService.addAddress(addressDto, userId);
                            const insurerAddress = new insurer_address_entity_1.InsurerAddress();
                            insurerAddress.insurerId = insurerId;
                            insurerAddress.addressId = updatedAddress.id;
                            // Add insurer address using transaction
                            await this.insurerRepository.addInsurerAddress(queryRunner, insurerAddress);
                        }
                        addressMappings.push(updatedAddress);
                    }
                }
                await this.insurerRepository.deleteEntityTableMapIds(constants_2.INSURER_MAP_TABLE_DELETE_FIELDS.INSURER_ADDRESS, existingAddressIds, constants_2.INSURER_MAP_TABLE_DELETE_FIELDS.ADDRESS_ID, constants_1.MAPPED_DATA_DELETION.MAP_REMOVED);
            }
            // Commit the transaction
            await queryRunner.commitTransaction();
            const response = {
                ...updatedInsurer,
                address: addressMappings,
            };
            // Remove metadata fields from the response
            (0, response_utils_1.removeMetadataFields)(response);
            return response;
        }
        catch (error) {
            // Rollback the transaction in case of an error
            await queryRunner.rollbackTransaction();
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            else if (error instanceof common_1.HttpException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToModifyInsurer));
        }
        finally {
            // Release the query runner
            await queryRunner.release();
        }
    }
    // Deletes an insurer by ID using the repository.
    async deleteInsurer(insurerId) {
        try {
            const insurer = await this.insurerRepository.fetchInsurerById(insurerId);
            if (!insurer) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.insurerNotFound));
            }
            await this.insurerRepository.softDeleteInsurer(insurerId);
            return { message: messages_1.successMessage.insurerDeleted };
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToDeleteInsurer));
        }
    }
    // Gets a list of insurers with pagination and sorting.
    async getInsurerList(page, limit, search, sortBy, sortOrder, userId) {
        try {
            const insurers = await this.insurerRepository.fetchInsurerList(page, limit, search, sortBy, sortOrder, userId);
            return insurers;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchInsurers));
        }
    }
    /** Fetches insurer contacts by insurer ID. */
    async getInsurerContacts(insurerId) {
        try {
            // Validate the insurer ID
            const insurer = await this.insurerRepository.fetchInsurerById(insurerId);
            if (!insurer) {
                throw new common_1.NotFoundException(messages_1.errorMessages.insurerNotFound);
            }
            const insurerContacts = await this.insurerRepository.fetchInsurerContacts(insurerId);
            if (!insurerContacts || insurerContacts.length === 0) {
                return [];
            }
            // Transform the data to return only necessary fields
            const transformedContacts = insurerContacts.map((contactMapping) => ({
                id: contactMapping.contact?.id,
                firstName: contactMapping.contact?.firstName,
                lastName: contactMapping.contact?.lastName,
                displayName: contactMapping.contact?.displayName,
            }));
            return transformedContacts;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchInsurerContacts || error.message));
        }
    }
    // Gets insurer details by ID and user ID.
    async getInsurerDetails(id, userId) {
        try {
            const fields = ["id", "insurerName", "displayName"];
            const relations = ["insurerAddresses.address"];
            const whereCondition = {
                id: id,
            };
            const insurerDetails = await this.insurerRepository.fetchInsurerDetails(fields, relations, whereCondition);
            const transformedData = {
                id: insurerDetails.id,
                insurerName: insurerDetails.insurerName,
                displayName: insurerDetails.displayName,
                insurerAddresses: insurerDetails.insurerAddresses?.map((address) => ({
                    id: address.address?.id,
                    address1: address.address?.address1,
                    city: address.address?.cityId,
                })),
            };
            return transformedData;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchInsurer));
        }
    }
};
exports.InsurerService = InsurerService;
exports.InsurerService = InsurerService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof insurer_repository_1.InsurerRepository !== "undefined" && insurer_repository_1.InsurerRepository) === "function" ? _a : Object, typeof (_b = typeof address_service_1.AddressService !== "undefined" && address_service_1.AddressService) === "function" ? _b : Object, typeof (_c = typeof look_up_repository_1.LookUpRepository !== "undefined" && look_up_repository_1.LookUpRepository) === "function" ? _c : Object, typeof (_d = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _d : Object, typeof (_e = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _e : Object, typeof (_f = typeof masters_validation_1.MasterValidationService !== "undefined" && masters_validation_1.MasterValidationService) === "function" ? _f : Object])
], InsurerService);
